import request from '@/utils/request'
const requestApi = {
  wms_goods_inventory_list: '/wms/warehouse/goods_inventory/'
}

export function goods_inventory_list (query) {
  return request({
    url: requestApi.wms_goods_inventory_list,
    method: 'get',
    params: query
  })
}
